import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  student: null,
  currentClass: null,
  formTeacher: null,
  currentSession: null,
  currentTerm: null,
  positions: null,
  results: [],
  subjects: [],
  psychomotors: [],
  loading: false,
  error: null,
};

const studentDataSlice = createSlice({
  name: 'studentData',
  initialState,
  reducers: {
    setStudentData: (state, action) => {
      const data = action.payload;
      state.student = data.student || null;
      state.currentClass = data.currentClass || null;
      state.formTeacher = data.formTeacher || null;
      state.currentSession = data.currentSession || null;
      state.currentTerm = data.currentTerm || null;
      state.positions = data.positions || null;
      state.results = data.results || [];
      state.subjects = data.subjects || [];
      state.psychomotors = data.psychomotors || [];
      state.loading = false;
      state.error = null;
    },
    setStudent: (state, action) => {
      state.student = action.payload;
    },
    setCurrentClass: (state, action) => {
      state.currentClass = action.payload;
    },
    setFormTeacher: (state, action) => {
      state.formTeacher = action.payload;
    },
    setCurrentSession: (state, action) => {
      state.currentSession = action.payload;
    },
    setCurrentTerm: (state, action) => {
      state.currentTerm = action.payload;
    },
    setPositions: (state, action) => {
      state.positions = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    setSubjects: (state, action) => {
      state.subjects = action.payload;
    },
    setPsychomotors: (state, action) => {
      state.psychomotors = action.payload;
    },
    updateResult: (state, action) => {
      const { id, term, updates } = action.payload;
      const resultIndex = state.results.findIndex(result => result.id === id);
      if (resultIndex !== -1) {
        const termKey = `${term}_term`;
        state.results[resultIndex] = {
          ...state.results[resultIndex],
          [termKey]: {
            ...state.results[resultIndex][termKey],
            ...updates,
          },
        };
      }
    },
    clearStudentData: (state) => {
      state.student = null;
      state.currentClass = null;
      state.formTeacher = null;
      state.currentSession = null;
      state.currentTerm = null;
      state.positions = null;
      state.results = [];
      state.subjects = [];
      state.psychomotors = [];
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setStudentData,
  setStudent,
  setCurrentClass,
  setFormTeacher,
  setCurrentSession,
  setCurrentTerm,
  setPositions,
  setResults,
  setSubjects,
  setPsychomotors,
  updateResult,
  clearStudentData,
  setLoading,
  setError,
} = studentDataSlice.actions;

export default studentDataSlice.reducer;